/**
 * Protected Route Component
 * 
 * Wraps routes that require authentication
 * Redirects to sign-in page if user is not authenticated
 */

import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from 'context/AuthContext';
import VuiBox from 'components/VuiBox';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <VuiBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        sx={{ backgroundColor: '#0f1535' }}
      >
        <CircularProgress color="info" />
      </VuiBox>
    );
  }

  if (!currentUser) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;

